import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const BlogSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-montserrat">
              Latest <span className="gradient-text">Insights</span>
            </h2>
            <p className="text-gray-600 mt-2">
              Expert perspectives on AI and software development trends
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8">
          <Card className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border-none shadow">
            <CardContent className="p-12 text-center">
              <div className="inline-block px-6 py-3 bg-emerald-50 rounded-full mb-6">
                <p className="text-emerald-600 font-medium text-lg">Coming Soon</p>
              </div>
              <h3 className="font-montserrat font-semibold text-xl mb-4">
                Latest Insights and Articles
              </h3>
              <p className="text-gray-600">
                We're preparing valuable insights and articles about AI and software development.<br />
                Stay tuned for our upcoming content!
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
